import { FourOhOh } from '@brighterion/br-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

function BadRequest() {
    const { t } = useTranslation();
    const history = useHistory();

    return <FourOhOh tFunc={t} onLinkClick={() => history.push('/')} />;
}

export default BadRequest;
